<template>
  <div class="math-container">
    <editor ref="editor" :answerHtml="answerHtml" @fullscreen-change="onFullscreenChange" />
  </div>
</template>

<script>
import editor from "@/components/editor";
import { localizedStrings } from "@/utils/lang/formularLocalizedString";

export default {
  data() {
    return {
      content: "x=\\frac{-b\\pm \\sqrt{b^2-4ac}}{2a}",
      richEditor: {
        dialogVisible: false,
        object: null,
        parameterName: "",
        instance: null,
      },
      resizeObserver: null,
    };
  },
  props: ["answerHtml"],
  emits: ["fullscreen-change"],
  mounted() {
    window.locale = localizedStrings;
    this.initResizeObserver();
    // 初始延迟调用一次，确保编辑器完全渲染后调整高度
    this.$nextTick(() => {
      this.resizeEditor();
    });
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  methods: {
    // 监听容器尺寸变化（弹窗拉伸、全屏切换等）
    initResizeObserver() {
      const container = this.$el;
      if (window.ResizeObserver && container) {
        this.resizeObserver = new ResizeObserver(() => {
          this.resizeEditor();
        });
        this.resizeObserver.observe(container);
      } else {
        // 降级方案：监听 window resize
        window.addEventListener('resize', this.resizeEditor);
      }
    },
    // 调用编辑器内部的 resize 方法（根据你使用的编辑器暴露的方法调整）
    resizeEditor() {
      if (this.$refs.editor && this.$refs.editor.editorResize) {
        this.$refs.editor.editorResize();
      } else if (this.$refs.editor && this.$refs.editor.editor) {
        // 例如 wangEditor 的 change 或 resize 方法
        const editor = this.$refs.editor.editor;
        if (editor && typeof editor.change === 'function') {
          editor.change();
        } else if (editor && editor.$textContainerElem) {
          // 手动触发高度重新计算
          editor.$textContainerElem.css('height', 'auto');
          const newHeight = editor.$textContainerElem.parent().height() - editor.$toolbarElem.height();
          editor.$textContainerElem.css('height', newHeight + 'px');
        }
      }
      // 如果无法直接调用，强制更新视图
      this.$forceUpdate();
    },
    handleChange(e) {
      console.log(e.target);
      console.log(e.target.getValue());
    },
    getValue() {
      this.content = this.$refs.formulaRef.getValue();
      console.log(this.content);
    },
    editorReady(instance) {
      this.richEditor.instance = instance;
      let currentContent = this.richEditor.object[this.richEditor.parameterName];
      this.richEditor.instance.setContent(currentContent);
      this.richEditor.instance.focus(true);
      // 编辑器就绪后也 resize 一次
      this.resizeEditor();
    },
    editorConfirm() {
      let content = this.richEditor.instance.getContent();
      this.richEditor.object[this.richEditor.parameterName] = content;
      this.richEditor.dialogVisible = false;
    },
    onFullscreenChange(isFull) {
      this.$emit('fullscreen-change', isFull);
      // 全屏切换后等待 DOM 更新再调整编辑器尺寸
      this.$nextTick(() => {
        this.resizeEditor();
      });
    },
  },
  components: {
    editor,
  },
};
</script>

<style lang="scss" scoped>
.math-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
::v-deep math-field {
  margin-bottom: 20PX;
  width: 80%;
  border-radius: 8PX;
}
.editor {
  flex: 1;
  min-height: 0;   /* 防止 flex 溢出 */
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
/* 确保富文本编辑器的内容区域撑满剩余空间 */
::v-deep .w-e-text-container {
  flex: 1;
  min-height: 0;
}
/* 其他透明样式保持不变 */
::v-deep .w-e-text-container,
::v-deep .w-e-toolbar,
::v-deep .w-e-bar,
::v-deep .w-e-menu,
::v-deep .w-e-text,
::v-deep [class*="w-e"] {
  background-color: transparent !important;
  background: transparent !important;
  border: none !important;
}
/* 文字颜色等样式可根据需要保留 */
::v-deep .w-e-text-container [data-slate-editor] {
  color: rgb(131, 248, 120) !important;
  font-weight: 1200;
  caret-color: rgb(245, 4, 4) !important;
}
::v-deep .w-e-text-container [data-slate-editor]::placeholder,
::v-deep .w-e-text-container [data-slate-editor] .placeholder {
  color: rgba(224, 255, 192, 0.7) !important;
}
::v-deep .w-e-menu,
::v-deep .w-e-menu i,
::v-deep .w-e-menu svg,
::v-deep .w-e-menu span,
::v-deep .w-e-menu button,
::v-deep .w-e-toolbar i,
::v-deep .w-e-toolbar svg,
::v-deep .w-e-toolbar span,
::v-deep .w-e-toolbar button {
  color: #d4ff9d !important;
  fill: #d4ff9d !important;
}
::v-deep .w-e-menu:hover {
  background: rgba(255, 255, 255, 0.15) !important;
  i, svg, span {
    color: #ffd966 !important;
    fill: #ffd966 !important;
  }
}
::v-deep .w-e-panel,
::v-deep .w-e-dropdown-panel,
::v-deep .w-e-modal {
  background: rgba(0, 0, 0, 0.85) !important;
  border: 1px solid #9dca67 !important;
  border-radius: 8px;
  color: #e0ffc0 !important;
  * {
    color: #e0ffc0 !important;
    fill: #e0ffc0 !important;
  }
  button, .w-e-item:hover {
    background: rgba(157, 202, 103, 0.2) !important;
  }
}
::v-deep svg:not([fill]) {
  fill: rgb(4, 217, 245) !important;
}
::v-deep .katex,
::v-deep .katex * {
  color: #e0ffc0 !important;
}
</style>